import { Alert, Box, Button } from '@chargify/custom-ui-components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { getAlertMsg, getAlertTitle } from '../utils';
import { Coupon } from '../../../../../models/subscription/types';
import { Currency } from '@chargify/formatters';

type Props = {
  onClick: () => void;
  coupon: Coupon;
  currency: Currency;
};

export const CouponSummary = ({ onClick, coupon, currency }: Props) => {
  const { t } = useTranslation(['subscriptions-manager']);
  const alertTitle = getAlertTitle(coupon, t, currency);
  const alertDescription = getAlertMsg(coupon, t, currency);
  return (
    <>
      <Alert color={'success'} icon={'receipt'} title={alertTitle}>
        <Alert.TextMessage>{alertDescription}</Alert.TextMessage>
      </Alert>
      <Box marginTop={5}>
        <Button
          color={'primary'}
          onClick={onClick}
          label={t('coupons.add_another_coupon')}
        />
      </Box>
    </>
  );
};
